import PhotoSwiper from '../src/PhotoSwiper.tsx';
export default PhotoSwiper;
